import { CdkMenuItem } from '@angular/cdk/menu';
import { Directive, ElementRef, Input } from '@angular/core';
export enum ZenMenuItemType {
  Default = 'default',
  Delete = 'delete'
}
@Directive({
    selector: '[zenMenuItem]',
    standalone: false
})
export class ZenMenuItemDirective {
  @Input('zenMenuItem') set type(type: ZenMenuItemType) {
    if (type)
      this.el.nativeElement.classList.add(type);

    this.el.nativeElement.classList.add('zen-menu-item');
  }
  constructor(private el: ElementRef) {
  }

}
